import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const d = {
  display: "block"
}, g = ({ size: l = 16, useVw: t, useRem: c, color: n, withColor: o, removeClassName: e, disableSSR: m, style: i, ...p }) => {
  const x = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ a.createElement(f, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-GTchicang", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: t ? ((l || 0) / 375 * 100).toFixed(5) + "vw" : l + (c ? "rem" : "px"), height: t ? ((l || 0) / 375 * 100).toFixed(5) + "vw" : l + (c ? "rem" : "px"), className: e ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: e ? "" : "32px-GTæä»"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: e ? "" : "normal",
        fill: o ? r(n, 0, "#262933") : "#262933",
        datafollowfill: o ? r(n, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M16.438 5.768a2.188 2.188 0 0 0-2.299 0l-7.2 4.448A2.188 2.188 0 0 0 5.9 12.077v8.054c0 .759.393 1.463 1.04 1.862l6.908 4.262.291.18a2.188 2.188 0 0 0 2.303.003l7.197-4.445a2.188 2.188 0 0 0 1.038-1.861V16.99l-1.638.655a.9.9 0 0 1-.669-1.671l5.296-2.118a.9.9 0 0 1 .668 1.671l-1.857.743v3.86a3.988 3.988 0 0 1-1.892 3.394l-7.197 4.445a3.988 3.988 0 0 1-4.198-.005l-.289-.179-.002-.001-6.905-4.26A3.988 3.988 0 0 1 4.1 20.13v-8.054c0-1.383.716-2.666 1.892-3.393l7.201-4.447a3.988 3.988 0 0 1 4.191 0l7.288 4.5a.9.9 0 1 1-.946 1.532l-7.288-4.501Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M11.408 14.189a2.444 2.444 0 0 0 0 3.456l2.153 2.153a2.444 2.444 0 0 0 3.456 0l2.153-2.153a2.444 2.444 0 0 0 0-3.456l-2.153-2.153a2.444 2.444 0 0 0-3.456 0l-2.153 2.153Zm1.273 2.183a.644.644 0 0 1 0-.91l2.153-2.153a.644.644 0 0 1 .91 0l2.153 2.153a.644.644 0 0 1 0 .91l-2.153 2.153a.644.644 0 0 1-.91 0l-2.153-2.153Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, s = g;
export {
  s as default
};
